import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { GroupRequest } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { startupsUrl } from '@src/lib/startups-url';
export const GroupRequestSEO = props => {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.groupRequest) {
    const seoProps = {};
    seoProps.title = props.groupRequest.title;
    seoProps.description = (props.groupRequest as any).body || props.groupRequest.title;
    const t1 = `/requests/${props.groupRequest.groupRequestId}`;
    let t2;
    if ($[2] !== t1) {
      t2 = startupsUrl(t1);
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    seoProps.url = t2;
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = props.groupRequest;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
GroupRequestSEO.fragments = {
  GroupRequest: () => gql`
    fragment _ on GroupRequest {
      id
    }
  `
};